import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CustomInvoiceHistoryState from "@tKgpco/Store/Data/InvoiceHistoy/InvoiceHistoryStateExtension";
import { Draft } from "immer";

const initialState: CustomInvoiceHistoryState = {
    clearInvoiceHistoryFilters: false,
    getInvoiceHistoryParams: {},
};
export const reducer = {
    "Custom/InvoiceHistory/ClearFilters": (
        draft: Draft<CustomInvoiceHistoryState>,
        action: CustomInvoiceHistoryState,
    ) => {
        draft.clearInvoiceHistoryFilters = action.clearInvoiceHistoryFilters;
        draft.getInvoiceHistoryParams = action.getInvoiceHistoryParams;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
